import { formatMetricValue, type ClientStatusDto } from '@citilight-monitor/contracts';
import { cn } from '../../lib/cn';
import { metricStatus, orderMetrics, ruleSummary } from '../../lib/metrics';
import { Meter, StatusChip } from '../atoms';

/**
 * The client's latest poll as headline numbers on the band: value, where it sits against its
 * alert threshold, and the rule. Reachability is left out: it has its own timeline below and shows
 * as an open issue when down.
 */
export function ReadingsBand({ status }: { status: ClientStatusDto }) {
  const { client, latest } = status;
  const metrics = orderMetrics(client.metrics).filter((m) => m.unit !== 'state');

  return (
    <dl aria-label="Latest readings" className="grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-[repeat(auto-fit,minmax(150px,1fr))]">
      {metrics.map((definition) => {
        const rule = metricStatus(status, definition.key);
        const raw = latest?.metrics[definition.key];
        const flagged = rule && rule.tone !== 'good';
        return (
          <div key={definition.key} className="flex min-w-0 flex-col gap-1.5">
            <dt className="truncate text-[13px] text-band-fg-secondary">{definition.label}</dt>
            <dd className={cn('font-display text-[34px] font-bold leading-none tracking-[-0.02em]', flagged ? 'text-[#ffb4ab]' : 'text-band-fg')}>
              {formatMetricValue(definition.unit, raw)}
            </dd>
            {definition.unit === 'percent' && raw !== undefined && (
              <Meter percent={raw} threshold={rule?.rule.threshold} tone={rule?.tone} onBand className="my-1" />
            )}
            <dd className="flex flex-col items-start gap-1.5 text-xs text-band-fg-muted">
              {flagged && <StatusChip tone={rule.tone} label={rule.label} />}
              <span>{rule ? ruleSummary(rule.rule, definition) : 'No alert rule'}</span>
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
